module.exports = __webpack_public_path__ + "static/media/icon-ficha-coleta.4589cb08.svg";